// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__CmzsA","bigColWidth":"Table_bigColWidth__11rjg","biggerColWidth":"Table_biggerColWidth__3Vf8o","row":"Table_row__1m9Eg","col":"Table_col__2s-Gc"};